const MuiDatePicker = {
  defaultProps: {
    views: ["month", "year", "day"],
    yearsPerRow: 3
  }
};
export {
  MuiDatePicker
};
//# sourceMappingURL=MuiDatePicker.js.map
